const certificate = `-----BEGIN CERTIFICATE-----
MIIFWjCCA0KgAwIBAgIQNzkyMDI1MDUyMTE4MjQ0MTANBgkqhkiG9w0BAQsFADCB
mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry
aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ
cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz
dHJpZXMuY29tMB4XDTI1MDUyMTE4MjQ0MVoXDTI2MDUyMzIwMjYzMlowggEUMQsw
CQYDVQQGDAJDQTELMAkGA1UECAwCUUMxDzANBgNVBAcMBlF1ZWJlYzEoMCYGA1UE
CgwfTWljcm9mbGV4IDIwMDEgTExDL1RpY2tldG1hc3RlcjEoMCYGA1UECwwfTWlj
cm9mbGV4IDIwMDEgTExDL1RpY2tldG1hc3RlcjEoMCYGA1UEAwwfTWljcm9mbGV4
IDIwMDEgTExDL1RpY2tldG1hc3RlcjErMCkGCSqGSIb3DQEJAQwccXVlYmVjYWRt
aW5AdGlja2V0bWFzdGVyLmNvbTE8MDoGA1UEDQwzcmVuZXdhbC1vZi01MTM0OTlm
ODE1MDJiMmI3MzA1OTljNDJlNDZhMjcwNmY2ZDA3YTRkMIIBIDALBgkqhkiG9w0B
AQEDggEPADCCAQoCggEBAOSdGJn815PTqyX4aPWiuqv63/1h/TIJPUETCvdfI04d
UMWFHg42XfZnQUQ5AuyRSjgPyr7GGWFOKP2aWxFao3HLJUg88KiiFDxzUXUaULAF
345Gn8faGS6UqUb2M4cu8G+CJtU0D2r/yKBrgi1dOWmJqVL8WbOzHcPGtHQ2PWdT
wyvxtzZ8ioQiHEPJ4zyaFg6wKFhytfGal1ZIkgw77Z8HDMEUDBOHbGav3NdZpZOO
SvXr8P4LpNhwLoHYIeJpwMFYlCGxVSqFVT0MTOf2oNUK3Nobplfrs8gOe3ngmFBL
YVVClTf3+qtLxYt7vQlY7BrnSbx2krdKHV/eYee4VIUCAwEAAaMjMCEwHwYDVR0j
BBgwFoAUkKZQt4TUuepf8gWEE3hF6Kl1VFwwDQYJKoZIhvcNAQELBQADggIBAJ9Z
pacwpNwa6p2ZvEPOaJja/H8aLat9CU3D6cSB2ZJxO+5bGAzg7B6JnkEeLtvJkbqn
TAYhepGrY69YW3LSrtmhUvewmiZTBEivX+KjO0jJXyjZACAdQ0JCfKXYjIRfI44n
7U5aNVI1BSclwhTvq8bsrZ1mvGopJ/x7vWgkpS5EPgyxAj+5HFotRWf9co9SJa3d
dF1+0pT2rdxE1yqo9KFA4Df1wzWJhsc2AiuM7y31fwIE7vxYWhSZb/lIMYZ81zfl
KZoRO7D9oMV9yr6FclkDF3K2GNzJcK13vSOOwzQmTG6M21HSyCHgz6bJB3CJjths
AGR6OiMI39Fdcn+jaWGds9PdXOsnAIcjAyb4/XB+V8YIOIsUdhp/wNoWWT2YHBpC
b4xa5hya0Y7J2fLwn5XmgauH/EGuaJhw2PsHkJ8uxwHLbO153c2OBF4pw4yheOq6
wIRcSV4NmJAwIFhZCgqUJg3YTlfnrr5t1EF2Rg3S2k/yTuqyQC3kWfy5VG93HSa4
ugUF7te/pbdmOfUR3Ta53CVE0Und1cerQdRiBjNuQ+mr8pg5vXP/s3/JGOm/Cjuy
hBa7V4weggv4aeTeUi3aK+PdB7G4se1kDc3veJ/zWShZOabqLd9ke+gVRyy5GsOo
//CCqD7bHxGMeYetrRcW9J5NHLFSS36IiDhlh+tb
-----END CERTIFICATE-----
--START INTERMEDIATE CERT--
-----BEGIN CERTIFICATE-----
MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
rbO7BnjW
-----END CERTIFICATE-----
`;
export default certificate;
